// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.orgstructure-content {\r\n    display: flex;\r\n    flex-direction: row;\r\n    height: 100%;\r\n    width: 100%;\r\n    padding: 5px 5px 0 5px;\n}\n.orgstructure-tree {\r\n    display: flex;\r\n    height: 100%;\r\n    flex-basis: 45%;\n}\n.orgstructure-card {\r\n    display: flex;\r\n    height: 100%;\r\n    flex-basis: 55%;\n}\r\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
